import { ApiClientResponse, JsonMimeType } from "@lib/ApiClient";
import ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { singleton } from "tsyringe";

import { LoggerInterface } from "@interfaces/LoggerInterface";

@singleton()
export class InstagramTrackersApiService {
    constructor(
        private readonly apiClient: ApiClientInterface,
        private readonly logger: LoggerInterface
    ) {}

    trackPostView(postId: number): Observable<ApiClientResponse<unknown>> {
        this.logger.debug("InstagramTrackService.trackPostView is started", {
            postId,
        });
        return this.apiClient
            .post({
                url: "/instagram/trackPostView",
                body: JSON.stringify({ postId }),
                responseType: "text",
                contentType: JsonMimeType,
            })
            .pipe(
                tap(() => {
                    this.logger.debug(
                        "InstagramTrackService.trackPostView is ready",
                        {
                            postId,
                        }
                    );
                })
            );
    }
}
